import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Icons } from '../../components/atoms/SVG';
import React from 'react';
import { MostPopularPagesBlock } from '../../_blocks/MostPopularPages/MostPopularPagesBlock';

export type MostPopularPagesWidgetProps = WidgetShape<[MostPopularPagesBlock], WidgetType.mostpopularpages>;

export function MostPopularPagesWidget({ blocks, ...headerProps }: MostPopularPagesWidgetProps) {
  const { t } = useSonTranslation('MostPopularPages');
  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      widgetType={WidgetType.mostpopularpages}
      icon={Icons.THUMB_LIKE}
      title={t('widgetTitle')}
    >
      {blocks[0] ? <MostPopularPagesBlock {...blocks[0]} /> : null}
    </DefaultWidgetWithHeader>
  );
}
